import React, { Component } from 'react'
import styles from './expired-wwc.styl'
import { FormattedMessage } from 'react-intl'
import { Title } from '../../misc'
import { ElevatedButton, FixedRightBottom } from '../index'
import MODALS from '../../../constants/layout/modals'
import { modal } from '../../../helpers/decorators'
import PropTypes from 'prop-types'

@modal.trigger()
class ExpiredWWC extends Component {
  static propTypes = {
    onOpen: PropTypes.func.isRequired
  }

  handleOpenWWCDialog = () => this.props.onOpen(MODALS.WWC_STATUS)

  render() {
    return (
      <div className={styles.wrapper}>
        <Title h1>
          <FormattedMessage
            id="moduleTitle.welcome_to_the_orb"
            defaultMessage="Welcome to the Online Record Book"
          />
        </Title>
        <p className={styles.message}>
          <FormattedMessage
            id="label.your_certificate_has_expired"
            defaultMessage="Your WWC/CPN Certificate has expired. You will be unable to access Participants records until you
            have uploaded a new certificate and submitted it for approval."
          />
          <br /> <br />
          <FormattedMessage
            id="label.upload_new_certificate"
            defaultMessage="Please go to the WWC status in menu item on your account and upload your new certificate.
             The certificate will be sent to the Participant´s Award Leader for review and approval."
          />
        </p>

        <FixedRightBottom>
          <ElevatedButton
            onClick={this.handleOpenWWCDialog}
            intlKey="button.your_wwc_has_expired"
            large
          >
            Your WWC has expired
          </ElevatedButton>
        </FixedRightBottom>
      </div>
    )
  }
}

export default ExpiredWWC
